module.exports = __webpack_public_path__ + "static/media/mob_education@2x.f594aa0a.png";